import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, map, join } from "lodash";

import { TableRow } from "@material-ui/core";

import TagColor from "../../Common/TagColor";
import FormSection from "../../Common/FormSection";
import TableCellStyled from "../../Common/TableCellStyled";

import { getAttributeValue } from "../../../utils/profile";
import { displayData } from "../../../utils/data";
import { formatPhone } from "../../../utils/form";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import ProfilePictureAndLink from "../../Common/ProfilePictureAndLink";

const styles = {
  dataCell: {
    color: colors.black54,
  },
};

const ProfileAssociationsRow = (props) => {
  const {
    classes,
    association,
    index,
    language,
    lov,
    editMode,
    handleEdit,
    edits,
  } = props;

  const profile = editMode
    ? get(association, ["p1_profile"])
    : get(association, [0, "p1_profile"]);

  const renderIndividualColumns = () => {
    return (
      <>
        <TableCellStyled className={classes.dataCell}>
          {displayData(formatPhone(getAttributeValue(profile, 34)))}
        </TableCellStyled>
        <TableCellStyled className={classes.dataCell}>
          {displayData(getAttributeValue(profile, 33))}
        </TableCellStyled>
      </>
    );
  };

  const renderObjectColumns = () => {
    return (
      <>
        <TableCellStyled className={classes.dataCell}>
          {displayData(getAttributeValue(profile, 89, lov, language))}
        </TableCellStyled>
        <TableCellStyled className={classes.dataCell}>
          {displayData(getAttributeValue(profile, 44))}
        </TableCellStyled>
        <TableCellStyled className={classes.dataCell}>
          {displayData(getAttributeValue(profile, 50))}
        </TableCellStyled>
        <TableCellStyled className={classes.dataCell}>
          {get(profile, ["type", `name_${language}`])}
        </TableCellStyled>
      </>
    );
  };

  return (
    <TableRow
      style={{
        backgroundColor: index % 2 === 0 ? colors.white : colors.lightGrey,
      }}
    >
      <TableCellStyled className={classes.dataCell}>
        <ProfilePictureAndLink profile={profile} />
      </TableCellStyled>
      <TableCellStyled className={classes.dataCell}>
        {!editMode ? (
          join(
            map(association, (ass) =>
              get(ass, ["p1_association_type", `name_${language}`])
            ),
            ", "
          )
        ) : (
          <FormSection
            formValue={[
              get(edits, [get(association, ["id"])]) ||
                get(association, ["p1_association_type", "id"]),
            ]}
            setFormValue={(name, index, value) =>
              handleEdit(get(association, ["id"]), value)
            }
            id={`p1_association_type_${get(association, ["id"])}`}
            title={`p1_association_type_${get(association, ["id"])}`}
            type="select"
            noLabel
            options={{
              comboBox: true,
              options: map(get(lov, ["association_types"]), (item) => ({
                id: item.id,
                name: get(item, [`name_${language}`]),
              })),
            }}
            noMarginBottom
          />
        )}
      </TableCellStyled>
      <TableCellStyled>
        <TagColor
          color={get(profile, ["tag", "color_rgb"])}
          name={get(profile, ["tag", `name_${language}`])}
        />
      </TableCellStyled>
      {get(profile, ["type", "id"]) === 1
        ? renderIndividualColumns()
        : renderObjectColumns()}
      {editMode && (
        <TableCellStyled className="text-center">
          <img
            src={images.deleteIcon}
            alt="delete"
            style={{ cursor: "pointer" }}
            onClick={() => handleEdit(get(association, ["id"]), null)}
          />
        </TableCellStyled>
      )}
    </TableRow>
  );
};

export default withStyles(styles)(ProfileAssociationsRow);
